<template>
  <v-container fluid>
    <div class="d-flex justify-space-between align-center py-2">
      <span class="font-weight-medium py-2 flex-shrink-0">รายการ Device</span>
      <v-scroll-x-transition>
        <div class="d-flex align-center" v-show="!formShow">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="text-capitalize"
                color="grey darken-3"
                outlined
                v-bind="attrs"
                v-on="on"
              >
                Sync Action
              </v-btn>
            </template>
            <v-list>
              <v-list-item-group>
                <v-list-item
                  dense
                  v-for="item in syncActionTypes"
                  :key="item.id"
                  @click="handleSyncActionType(item.value)"
                >
                  <v-list-item-content>
                    <v-list-item-title
                      :class="
                        item.value === 'sync_all'
                          ? 'green--text'
                          : 'warning--text'
                      "
                    >
                      {{ item.text }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-menu>
          <v-text-field
            v-model="search"
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            dense
            hide-details
            placeholder="รหัส - ชื่อ Device"
            @input="handleSearch"
            style="width: 220px; padding: 0 5px"
          ></v-text-field>
          <v-autocomplete
            v-model="filterArea"
            :items="
              this.areas.length
                ? [
                    {
                      title_th: 'ไม่ระบุพื้นที่',
                      area_uuid: 'not_specified',
                    },
                    ...areas,
                  ]
                : []
            "
            :loading="loadingAreas"
            item-text="title_th"
            item-value="area_uuid"
            label="พื้นที่"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            style="width: 240px; background-color: white; margin-right: 5px"
            @change="handleFilterArea"
          ></v-autocomplete>
          <v-autocomplete
            v-model="filterSyncPending"
            :items="[
              { id: 1, text: 'Sync', value: false },
              { id: 2, text: 'Wait Sync', value: true },
            ]"
            item-text="text"
            item-value="value"
            label="สถานะ Sync"
            prepend-inner-icon="mdi-filter-variant"
            clearable
            dense
            outlined
            hide-details
            style="width: 200px; background-color: white; margin-right: 5px"
            @change="handleFilterSyncPending"
          ></v-autocomplete>
          <!-- <v-select
            v-model="filterDeviceType"
            style="width: 246px; background-color: white"
            :items="[
              { text: 'Access Control', value: true },
              { text: 'Time Attendance', value: false },
            ]"
            item-text="text"
            item-value="value"
            outlined
            dense
            label="ประเภท Device"
            hide-details
            prepend-inner-icon="mdi-filter-variant"
            clearable
            @change="handleFilterDeviceType"
          ></v-select> -->
        </div>
      </v-scroll-x-transition>
    </div>
    <v-data-table
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      :loading="isFetching"
      loading-text="Loading... Please wait"
      :headers="headers"
      :items="hardwares"
      :options.sync="options"
      :server-items-length="totalHardwares"
      :items-per-page="10"
      class="elevation-1"
      :footer-props="{
        itemsPerPageOptions: [10, 25, 50, 100],
        itemsPerPageText: 'Rows per page:',
      }"
      :item-class="classRowSelected"
      @click:row="handleRowSelected"
      multi-sort
    >
      <template v-slot:item.area_code="{ item }">
        <div v-if="!item.area" class="grey--text text-darken-1">-</div>
        <div v-else>
          <div>{{ item.area.area_code }}</div>
          <div class="caption grey--text text--darken-1">
            {{ item.area.title_th }}
          </div>
        </div>
      </template>
      <template v-slot:item.title_hardware_model="{ item }">
        <div>{{ item.hardware_model ? item.hardware_model.title : '' }}</div>
      </template>
      <template v-slot:item.title_th_hardware_status="{ item }">
        <div>
          {{ item.hardware_status ? item.hardware_status.title_th : '' }}
        </div>
      </template>
      <template v-slot:item.communication="{ item }">
        <div class="body-2 green--text">
          <span>
            {{ item.communication ? item.communication.message : '' }}
          </span>
          <div
            v-if="
              item.communication &&
              (item.communication.datetime || item.communication.updated_at)
            "
          >
            <span v-if="item.communication.updated_at">
              {{ item.communication.updated_at | dateTimeFormat }}
            </span>
            <span v-else>
              {{ item.communication.datetime | dateTimeFormat }}
            </span>
          </div>
        </div>
      </template>
      <template v-slot:item.title_th="{ item }">
        <div style="min-width: 200px">{{ item.title_th }}</div>
      </template>
      <template v-slot:item.hardware_status.title_th="{ item }">
        <span
          v-if="
            item.hardware_status &&
            item.hardware_status.title_th === 'อยู่ระหว่างซ่อม'
          "
          class="red--text"
        >
          {{ item.hardware_status.title_th }}
        </span>
        <span v-else>{{ item.hardware_status.title_th }}</span>
      </template>
      <template v-slot:item.register_user="{ item }">
        <div v-if="item.register_user">
          {{ item.register_user }}
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.authority_user="{ item }">
        <div v-if="item.authority_user">
          {{ item.authority_user }}
        </div>
        <div v-else>-</div>
      </template>
      <template v-slot:item.sync_action="{ item }">
        <div
          v-if="
            [
              'vf1000',
              'vf1000r',
              'acu01r',
              'vf600',
              'acu81',
              'acu81r',
              'tat51i',
              'cru67rc',
              'cru67rf',
              'cru77rf',
              'q3rac',
            ].includes(item.hardware_model.hardware_model_code) &&
            item.hardware_status.title_th !== 'อยู่ระหว่างซ่อม'
          "
        >
          <v-btn
            outlined
            :color="`${item.is_sync_pending ? 'warning' : 'success'}`"
            small
            @click.stop="handleSyncAction(item)"
            :disabled="
              item.sync_status.is_sync_process ||
              !item.is_connected ||
              (uiCtrl && !uiCtrl.isEnable('btn:::hardware:update'))
            "
          >
            <v-progress-linear
              v-if="item.sync_status.is_sync_process"
              indeterminate
              color="primary"
              style="width: 50px"
            ></v-progress-linear>
            <span v-else class="text-capitalize">
              {{ item.is_sync_pending ? 'Wait Sync' : 'Sync' }}
            </span>
          </v-btn>
          <v-btn
            v-if="item.sync_status.is_sync_process"
            icon
            small
            @click.stop="handleSyncActionCancel(item)"
          >
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.sync_done_datetime="{ item }">
        <span
          v-if="
            item.sync_status &&
            item.sync_done_datetime &&
            !item.sync_status.is_sync_process
          "
        >
          <button
            type="button"
            class="btn-text"
            style="color: #000000de"
            @click.stop="handleClickSyncStatus(item, 'done')"
          >
            {{ item.sync_done_datetime | dateTimeFormat }}
          </button>
        </span>
        <span v-else-if="item.sync_status.is_sync_process">
          <button
            type="button"
            class="btn-text"
            @click.stop="handleClickSyncStatus(item, 'syncing')"
          >
            ดูรายละเอียด
          </button>
        </span>
        <span v-else> - </span>
      </template>
      <template v-slot:item.connected_at="{ item }">
        <div>
          <div>
            <span v-if="item.connected_at">
              {{ item.connected_at | dateTimeFormat }}
            </span>
            <span v-else>-</span>
          </div>
          <div
            :class="`caption ${
              item.is_connected
                ? 'green--text text-lighten-2'
                : 'red--text text--lighten-2'
            }`"
          >
            {{ item.is_connected ? 'Connected' : 'Disconnected' }}
          </div>
        </div>
      </template>
      <!-- <template v-slot:item.is_access_control="{ item }">
        <div>
          <span v-if="item.is_access_control">Access Control</span>
          <span v-else>Time Attendance</span>
        </div>
      </template> -->
    </v-data-table>
    <HardwareDeviceForm
      :formShow="formShow"
      :hardware="hardware"
      :hardwareInit="hardwareInit"
      @isHardwareDataChange="handleHardwareFormDataChange"
      @formActionCompleted="handleHardwareFormActionCompleted"
      @onReset="handleHardwareFormReset"
      @onClickCommand="handleClickCommand"
    />
    <HardwareDeviceFormCommand
      :isShowForm="isShowFormCommand"
      :hardware="hardware"
      :commandData="commandDataFormCommand"
      @onClickBack="handleHardwareDeviceFormCommandClickBack"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ConfirmDialog
      :dialog="confirmDialogSync"
      :loading="confirmDialogSyncLoading"
      :dialogData="confirmDialogSyncData"
      @cancelConfirmDialog="cancelConfirmDialogSync"
      @submitConfirmDialog="submitConfirmDialogSync"
    />
    <ConfirmDialog
      :dialog="confirmDialogSyncCancel"
      :loading="confirmDialogSyncCancelLoading"
      :dialogData="confirmDialogSyncCancelData"
      @cancelConfirmDialog="cancelConfirmDialogSyncCancel"
      @submitConfirmDialog="submitConfirmDialogSyncCancel"
    />
    <v-overlay :value="isShowFormCommand" z-index="0"></v-overlay>
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
    <v-dialog v-model="dialogSyncAllConfirm" persistent max-width="480">
      <v-card>
        <v-card-title class="text-h5">
          ยืนยันการ Sync ข้อมูลทั้งหมด
        </v-card-title>
        <v-card-text>
          จำนวน Device ที่จะ Sync {{ totalSyncAllDevice }} เครื่อง
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="loadingSyncAll"
            text
            @click="dialogSyncAllConfirm = false"
          >
            ยกเลิก
          </v-btn>
          <v-btn
            :loading="loadingSyncAll"
            color="primary"
            text
            @click="handleSubmitConfirmSyncAll"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import HardwareDeviceForm from '@/views/hardware-device/HardwareDeviceForm.vue'
import HardwareDeviceFormCommand from '@/views/hardware-device/HardwareDeviceFormCommand'

export default {
  components: {
    HardwareDeviceForm,
    HardwareDeviceFormCommand,
    ConfirmDialog,
  },
  data() {
    return {
      filterDeviceType: null,
      syncActionTypes: [
        { id: 1, text: 'Sync All Device', value: 'sync_all' },
        { id: 2, text: 'Wait Sync Device', value: 'wait_sync' },
      ],
      loadingSyncAll: false,
      dialogSyncAllConfirm: false,
      syncAllDeviceItems: [],
      totalSyncAllDevice: 0,

      isFetching: false,
      timerId: null,
      cancelSource: null,

      options: {},
      filterArea: null,
      filterSyncPending: null,
      dialogForbidden: false,
      commandComponentType: {
        get_device_info: 'HardwareGetDeviceInfo',
        get_device_log: 'HardwareGetDeviceLog',
        get_employee: 'HardwareGetEmployee',
        get_employee_list: 'HardwareGetEmployeeList',
        get_access_authority_list: 'HardwareGetAccessAuthorityList',
        set_firmware: 'HardwareSetFirmware',
      },
      isShowFormCommand: false,
      commandDataFormCommand: {},
      sortBy: ['area_code', 'hardware_code'],
      sortDesc: [false, false],
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      confirmDialogSync: false,
      confirmDialogSyncLoading: false,
      confirmDialogSyncData: {},
      confirmDialogSyncCancel: false,
      confirmDialogSyncCancelLoading: false,
      confirmDialogSyncCancelData: {},
      loadingAreas: false,
      search: '',
      formShow: false,
      hardware: {
        network: {},
      },
      hardwareInit: {
        network: {},
      },
      isHardwareDataChange: false,
      timeout: null,
      headers: [
        { text: 'พื้นที่', width: 200, value: 'area_code' },
        { text: 'รหัส Device', width: 140, value: 'hardware_code' },
        { text: 'คำอธิบาย', value: 'title_th' },
        { text: 'ชื่อรุ่น Device', width: 140, value: 'title_hardware_model' },
        {
          text: 'การสื่อสาร',
          width: 260,
          value: 'communication',
          sortable: false,
        },
        {
          text: 'Sync Action',
          width: 145,
          value: 'sync_action',
          sortable: false,
        },
        {
          text: 'พนักงาน TA',
          align: 'center',
          width: 125,
          value: 'register_user',
          sortable: false,
        },
        {
          text: 'พนักงาน ACC',
          align: 'center',
          width: 125,
          value: 'authority_user',
          sortable: false,
        },
        {
          text: 'Sync ล่าสุด',
          width: 165,
          value: 'sync_done_datetime',
          sortable: false,
        },
        { text: 'Connect ล่าสุด', width: 165, value: 'connected_at' },
        { text: 'Serial Number', width: 200, value: 'hardware_serial_number' },
        { text: 'สถานะ Device', width: 140, value: 'title_th_hardware_status' },
        // { text: 'ประเภท Device', width: 140, value: 'is_access_control' },
      ],
    }
  },
  filters: {
    dateTimeFormat: function (value) {
      if (!value) return
      return moment(value).format('DD/MM/YYYY HH:mm:ss')
    },
  },
  watch: {
    options: {
      handler() {
        this.restartPolling()
      },
      deep: true,
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    hardwares() {
      return this.$store.state.hardware.hardwares
    },
    totalHardwares() {
      return this.$store.state.hardware.totalHardwares
    },
    areas() {
      return this.$store.state.area.areas
    },
  },
  async created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'รายการ Device',
        disabled: true,
      },
    ])

    try {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: { dpc: 'hardware-to-list-area' },
      }

      this.loadingAreas = true

      this.fetchAreas(payload)
    } catch (error) {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    } finally {
      this.loadingAreas = false
    }
  },
  methods: {
    ...mapActions({
      fetchHardware: 'hardware/fetchHardware',
      fetchAreas: 'area/fetchAreas',
      cancelJob: 'hardware/cancelJob',
      getLastUpdate: 'hardware/getLastUpdate',
      fetchHardwares: 'hardware/fetchHardwares',
      fetchHardwaresSyncAll: 'hardware/fetchHardwaresSyncAll',
      getNetworkConfig: 'hardware/getNetworkConfig',
    }),
    async handleSyncActionType(value) {
      try {
        const { company_uuid } = this.$store.state.authentication.company
        const payload = {
          params: {
            company_uuid,
            dpc: 'hardware-to-list-hardware',
          },
        }
        this.$store.state.loading = true
        const response = await this.fetchHardwaresSyncAll(payload)

        const items = response.filter((h) => {
          if (value === 'sync_all')
            return h.is_connected && h.sync_status.is_sync_process === false
          else if (value === 'wait_sync')
            return (
              h.is_sync_pending &&
              h.is_connected &&
              h.sync_status.is_sync_process === false
            )
        })

        if (items.length === 0) {
          const snackbar = {
            show: true,
            color: 'warning',
            timeout: 4000,
            message: 'ไม่มี Device ที่จะ Sync',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
          return
        }

        this.syncAllDeviceItems = items
        this.totalSyncAllDevice = items.length
        this.dialogSyncAllConfirm = true
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.$store.state.loading = false
      }
    },
    async handleSubmitConfirmSyncAll() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.loadingSyncAll = true

        for (const item of this.syncAllDeviceItems) {
          await this.getLastUpdate({
            company_uuid,
            hardware_model: item.hardware_model.hardware_model_code,
            body: {
              hardware_uuid: item.hardware_uuid,
              data: null,
            },
          })
        }

        let fetchDataOneTime = true
        await this.fetchData(fetchDataOneTime)

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ส่งคำสั่งเรียบร้อยแล้ว',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingSyncAll = false
        this.dialogSyncAllConfirm = false
      }
    },
    handleSearch() {
      this.getHardwaresBySearch()
    },
    handleFilterArea() {
      this.options.page = 1
      this.restartPolling()
    },
    handleFilterDeviceType() {
      this.options.page = 1
      this.restartPolling()
    },
    handleFilterSyncPending() {
      this.options.page = 1
      this.restartPolling()
    },
    getHardwaresBySearch: _.debounce(function () {
      this.options.page = 1
      this.restartPolling()
    }, 1000),
    async fetchData(fetchDataOneTime = false) {
      if (this.isFetching) return
      this.isFetching = true

      const controller = new AbortController()
      this.cancelSource = controller

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const sortParams = sortBy
        .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
        .join(',')

      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          params: {
            company_uuid,
            dpc: 'hardware-to-list-hardware',
            search: this.search || undefined,
            area_uuid: this.filterArea || undefined,
            is_sync_pending:
              this.filterSyncPending === null
                ? undefined
                : this.filterSyncPending,
            is_access_control:
              this.filterDeviceType === null
                ? undefined
                : this.filterDeviceType,
            is_manageable: true,
            sort: sortParams || undefined,
            limit: itemsPerPage,
            offset: (page - 1) * itemsPerPage,
          },
          signal: controller.signal,
        }

        await this.fetchHardwares(payload)
      } catch (error) {
        if (error.name === 'CanceledError') {
          // Request was cancelled, do nothing
          return
        }

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.isFetching = false
        fetchDataOneTime === false && this.scheduleNext()
      }
    },
    scheduleNext() {
      this.timerId = setTimeout(this.fetchData, 1000 * 5) // 5 second;
    },
    restartPolling() {
      clearTimeout(this.timerId)
      if (this.cancelSource) {
        this.cancelSource.abort()
      }
      this.fetchData()
    },
    async handleClickSyncStatus(item, type) {
      this.$store.commit('hardware/SET_SYNC_DEVICE_BUTTON_TYPE', type)
      this.$store.commit(
        'hardware/SET_SELECTED_SYNC_DEVICE_HARDWARE',
        item.hardware_uuid
      )
      this.$store.commit('hardware/SET_DIALOG_SYNC_DEVICE', true)
    },
    cancelConfirmDialogSync() {
      this.confirmDialogSync = false
    },
    async submitConfirmDialogSync(item) {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          hardware_model: item.hardware_model.hardware_model_code,
          body: {
            hardware_uuid: item.hardware_uuid,
            data: null,
          },
        }

        this.confirmDialogSyncLoading = true

        await this.getLastUpdate(payload)
        this.$store.commit('hardware/EDIT_HARDWARE', {
          ...item,
          sync_status: {
            ...item.sync_status,
            is_sync_process: true,
          },
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ส่งคำสั่งเรียบร้อยแล้ว',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogSyncLoading = false
        this.confirmDialogSync = false
      }
    },
    cancelConfirmDialogSyncCancel() {
      this.confirmDialogSyncCancel = false
    },
    async submitConfirmDialogSyncCancel(item) {
      try {
        this.confirmDialogSyncCancelLoading = true

        await this.cancelJob(item.hardware_uuid)
        this.$store.commit('hardware/EDIT_HARDWARE', {
          ...item,
          sync_status: {
            ...item.sync_status,
            is_sync_process: false,
          },
        })

        const snackbar = {
          show: true,
          color: 'success',
          timeout: 2000,
          message: 'ยกเลิกคำสั่งเรียบร้อยแล้ว',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.confirmDialogSyncCancelLoading = false
        this.confirmDialogSyncCancel = false
      }
    },
    handleSyncAction(item) {
      const details = []
      if (item.time_attendance_user !== null) {
        details.push({
          id: 1,
          text: 'จำนวนพนักงาน time attendance',
          value: item.time_attendance_user,
        })
      }
      if (item.access_control_user !== null) {
        details.push({
          id: 2,
          text: 'จำนวนพนักงาน access control',
          value: item.access_control_user,
        })
      }

      this.confirmDialogSync = true
      this.confirmDialogSyncData = {
        title: 'ยืนยันการ Sync ข้อมูล',
        text: 'คุณต้องการ Sync ข้อมูล',
        value: item.title_th,
        details,
        item: { ...item },
      }
    },
    handleSyncActionCancel(item) {
      this.confirmDialogSyncCancel = true
      this.confirmDialogSyncCancelData = {
        title: 'ยืนยันการยกเลิก Sync ข้อมูล',
        text: 'คุณต้องการยกเลิก Sync ข้อมูล',
        value: item.title_th,
        item: { ...item },
      }
    },
    handleHardwareDeviceFormCommandClickBack() {
      this.isShowFormCommand = false
      this.timeout = setTimeout(() => {
        this.commandDataFormCommand = {}
      }, 200)
    },
    handleClickCommand(command) {
      if (
        [
          'get_device_info',
          'get_device_log',
          'get_employee',
          'get_employee_list',
          'get_access_authority_list',
          'set_firmware',
        ].includes(command.sync_code)
      ) {
        this.commandDataFormCommand = {
          title: command.title,
          component: this.commandComponentType[command.sync_code],
          syncCode: command.sync_code,
        }
        this.isShowFormCommand = true
        return
      }
    },
    classRowSelected(row) {
      if (this.hardware.hardware_uuid === row.hardware_uuid)
        return 'row-selected'
    },
    async setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::hardware:get')) {
        this.dialogForbidden = true
        return
      }

      try {
        const payload = {
          hardware_uuid: row.hardware_uuid,
        }

        await this.fetchHardware(payload)
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      if (this.hardware.hardware_uuid === row.hardware_uuid) {
        this.formShow = false
        this.hardware = {
          network: {},
        }
        this.hardwareInit = {
          network: {},
        }
      } else {
        const { company_uuid } = this.$store.state.authentication.company

        this.$store.state.loading = true

        const payload = {
          company_uuid,
          hardware_model: row.hardware_model.hardware_model_code,
          body: {
            hardware_uuid: row.hardware_uuid,
          },
        }

        this.getNetworkConfig(payload)
          .then(({ network }) => {
            this.$store.state.loading = false

            this.formShow = true
            this.hardware = {
              ...row,
              area_uuid: row.area?.area_uuid || null,
              hardware_model_title: row.hardware_model
                ? row.hardware_model.title
                : '',
              hardware_status_title: row.hardware_status
                ? row.hardware_status.title_th
                : '',
              network: { ...network } || {},
            }
            this.hardwareInit = {
              ...row,
              area_uuid: row.area?.area_uuid || null,
              hardware_model_title: row.hardware_model
                ? row.hardware_model.title
                : '',
              hardware_status_title: row.hardware_status
                ? row.hardware_status.title_th
                : '',
              network: { ...network } || {},
            }
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    handleRowSelected(row) {
      if (this.isHardwareDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleHardwareFormDataChange(value) {
      this.isHardwareDataChange = value
    },
    handleHardwareFormReset() {
      if (
        this.hardware.hardware_model &&
        ['vf600', 'vf1000', 'vf1000r', 'acu01r', 'cru67rc', 'cru67rf'].includes(
          this.hardware.hardware_model.hardware_model_code
        )
      ) {
        this.hardware = {
          ...this.hardwareInit,
          network: { ...this.hardwareInit.network },
        }
      } else {
        this.hardware = { ...this.hardwareInit }
      }
    },
    handleHardwareFormActionCompleted(formAction) {
      this.hardware = {
        network: {},
      }
      this.hardwareInit = {
        network: {},
      }
      this.formShow = false
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.formShow = false
      this.isShowFormCommand = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isHardwareDataChange || this.isShowFormCommand) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timerId)
    if (this.cancelSource) {
      this.cancelSource.abort()
    }

    clearTimeout(this.timeout)
  },
}
</script>
